'use client';

import { useRouter, useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';

import { createMailtoLink } from '@/features/common/config/contact';
import { CommonModal } from '@/features/common/ui/CommonModal';

/**
 * TikTok 핸들 중복 에러 모달
 *
 * URL에 `?error=handle_already_linked&handle=@xxx`가 있으면 표시됩니다.
 * 다른 계정에 이미 연동된 TikTok 핸들이 있을 때 CS 안내를 보여줍니다.
 */
export const TikTokHandleConflictModal = () => {
  const searchParams = useSearchParams();
  const router = useRouter();
  const [isOpen, setIsOpen] = useState(false);
  const [handle, setHandle] = useState<string | null>(null);

  useEffect(() => {
    const error = searchParams.get('error');
    const handleParam = searchParams.get('handle');

    if (error === 'handle_already_linked') {
      setHandle(handleParam);
      setIsOpen(true);
    }
  }, [searchParams]);

  const handleClose = () => {
    setIsOpen(false);
    // URL에서 에러 파라미터 제거
    const url = new URL(window.location.href);
    url.searchParams.delete('error');
    url.searchParams.delete('handle');
    router.replace(url.pathname + url.search);
  };

  const handleContactSupport = () => {
    window.location.href = createMailtoLink(
      'TikTok Handle Conflict',
      `My TikTok handle ${handle || ''} is already linked to another account.`,
    );
  };

  return (
    <CommonModal
      isOpen={isOpen}
      onClose={handleClose}
      title="TikTok Account Already Linked"
      description={[
        `The TikTok account ${handle} is already linked to another Popow account.`,
        'Each TikTok account can only be connected to one Popow account.',
        'If you believe this is an error, please contact our support team.',
      ]}
      primaryActionText="Contact Support"
      onPrimaryAction={handleContactSupport}
      secondaryActionText="Close"
      onSecondaryAction={handleClose}
    />
  );
};
